import { Block, Flex } from '@aloft/toolkit-sui';

import { MainLayout } from '../../layout/MainLayout.tsx';
import { ModuleContainer } from '../../layout/ModuleContainer.tsx';
import { selectDeviceWidth } from '../../redux/features/selectors/uiSelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { Tkv2OrderTable } from './components/OrderTable/Tkv2OrderTable.tsx';
import { Updates } from './components/OrdersList/Updates.tsx';
import { useActiveOrderTabState } from './hooks/useActiveOrderTabState.ts';
import { useBackfillOrders } from './hooks/useBackfillTrainingOrders.ts';
import { Tkv2OrderManagementDeps } from './types.ts';
import { getOrdersByTab } from './utils/getOrdersForTab.ts';

import './Tkv2OrderModule.scss';

export const Tkv2OrderManagementModule = (props: Tkv2OrderManagementDeps) => {
  const [activeTab] = useActiveOrderTabState();

  const { orders, getOpenOrderRoute } = props;
  const deviceWidth = useAppSelector(selectDeviceWidth);

  useBackfillOrders(orders);

  const ordersByTab = getOrdersByTab(orders);

  return (
    <MainLayout title="Appraiser Toolkit" showNav={false}>
      <Flex className="tkv2-order-module" width="100%" height="100%">
        <Block flexGrow={1} overflow="auto" position="relative">
          <ModuleContainer
            compact
            moduleID="order-management"
            title="My Orders"
            hideTitleBorderBottom
          >
            <Tkv2OrderTable
              ordersByTab={ordersByTab}
              getOpenOrderRoute={getOpenOrderRoute}
              isViewingArchived={activeTab === 'archived'}
              isViewingTraining={activeTab === 'training'}
              isViewingCompleted={activeTab === 'completed'}
            />
          </ModuleContainer>
        </Block>

        {deviceWidth !== 'phone' && deviceWidth !== 'tablet' && (
          <Block width="25rem">
            <Updates />
          </Block>
        )}
      </Flex>
    </MainLayout>
  );
};
